import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';

const MONTHS = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
const SECTION = { ar: 'AR (ARS)', intl: 'INT (USD)' };
const fmt = (v) => Math.round(v).toLocaleString('es-AR');

export const EdrUnmatchedRows = ({ rows }) => {
  const [open, setOpen] = useState(false);
  if (!rows || rows.length === 0) return null;
  const monthKeys = [...new Set(rows.flatMap((r) => Object.keys(r.months || {})))].sort();

  return (
    <div className="flex justify-end mb-1" data-testid="edr-unmatched-banner">
      <div className="relative inline-block">
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          title={`${rows.length} ${rows.length === 1 ? 'fila' : 'filas'} del EDR sin contabilizar`}
          className="flex items-center gap-1 px-2 py-1 rounded text-yellow-600/50 hover:text-yellow-500/80 transition-colors"
          data-testid="edr-unmatched-toggle"
        >
          <AlertTriangle size={13} className="shrink-0" />
          <span className="text-[11px] text-yellow-600/50">{rows.length}</span>
        </button>

        {open && (
          <div
            className="absolute right-0 top-full mt-1 z-50 w-max max-w-[92vw] rounded-lg border border-neutral-700 bg-neutral-900 shadow-xl"
            data-testid="edr-unmatched-table"
          >
            <div className="flex items-center justify-between px-3 py-2 border-b border-neutral-800">
              <span className="text-[11px] text-yellow-500/70 font-medium">
                {rows.length} {rows.length === 1 ? 'fila' : 'filas'} sin contabilizar en el EDR
              </span>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="text-gray-600 hover:text-gray-400 text-xs ml-4"
              >✕</button>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-xs">
                <thead>
                  <tr className="text-[10px] uppercase tracking-wider text-gray-500 border-b border-neutral-800">
                    <th className="px-3 py-2 text-left">Fila</th>
                    <th className="px-3 py-2 text-left">Concepto</th>
                    <th className="px-3 py-2 text-left">Sección</th>
                    {monthKeys.map((m) => (
                      <th key={m} className="px-3 py-2 text-right">{MONTHS[Number(m.slice(5, 7)) - 1]}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r) => (
                    <tr key={r.row} className="border-b border-neutral-800/60" data-testid={`edr-unmatched-row-${r.row}`}>
                      <td className="px-3 py-2 font-mono text-gray-600">{r.row}</td>
                      <td className="px-3 py-2 text-gray-300 font-medium">{r.label}</td>
                      <td className="px-3 py-2 text-gray-500">{SECTION[r.section] || 'Sin sección'}</td>
                      {monthKeys.map((m) => (
                        <td key={m} className="px-3 py-2 text-right font-mono text-gray-400">
                          {r.months?.[m] ? fmt(r.months[m]) : '—'}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
